import { createContext, useCallback, useContext,useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

// Create a context for the confirmation dialog.
const ConfirmationDialogContext = createContext();

// Custom hook to access the confirmation dialog.
export const showConfirmation = () => {
  return useContext(ConfirmationDialogContext);
};

export const ConfirmationDialogProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState({
    title: 'Confirm Action',
    description: 'Are you sure you want to proceed?',
    cancelText: 'Cancel',
    confirmText: 'Confirm',
    onConfirm: () => {},
    onCancel: () => {}
  });

  // Function to show the dialog with optional overrides.
  const showConfirmation = useCallback((opts = {}) => {
    setOptions(prev => ({ ...prev, ...opts }));
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    if (options.onCancel) options.onCancel();
    setOpen(false);
  }, [options]);

  const handleConfirm = useCallback(() => {
    if (options.onConfirm) options.onConfirm();
    setOpen(false);
  }, [options]);

  return (
    <ConfirmationDialogContext.Provider value={{ showConfirmationDialog: showConfirmation }}>
      {children}
      <Modal isOpen={open} toggle={handleClose} backdrop="static" fade={false}>
        <ModalHeader toggle={handleClose}>
          {options.title || 'Confirm Action'}
        </ModalHeader>
        <ModalBody
          dangerouslySetInnerHTML={{ __html: options.description || 'Are you sure?' }}
        />
        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            {options.cancelText || 'Cancel'}
          </Button>
          <Button color="primary" onClick={handleConfirm}>
            {options.confirmText || 'Confirm'}
          </Button>
        </ModalFooter>
      </Modal>
    </ConfirmationDialogContext.Provider>
  );
};
